export enum RECEIPT_STATUS {
  PAYMENT_PENDING = "PAYMENT_PENDING",
  PENDING = "PENDING",
  POSTED = "POSTED",
  FAILED = "FAILED",
}
